import { useState, useEffect } from 'react';
import { injectScriptTag } from '../browserUtils';
const useScript = (src, additionalAttributes = {}) => {
    const [state, setState] = useState({
        loaded: false,
        error: false,
    });
    const handleMissing = () => {
        setState({
            loaded: false,
            error: true,
        });
    };
    const handleExists = () => {
        setState({
            loaded: true,
            error: false,
        });
    };
    const handleLoaded = () => {
        setState({
            loaded: true,
            error: false,
        });
    };
    const handleError = () => {
        setState({
            loaded: true,
            error: true,
        });
    };
    useEffect(() => {
        if (!src) {
            handleMissing();
            return;
        }
        const onStateUpdate = (currentStatus, Statuses) => {
            switch (currentStatus) {
                case Statuses.EXISTS:
                    handleExists();
                    break;
                case Statuses.LOADED:
                    handleLoaded();
                    break;
                case Statuses.ERROR:
                    handleError();
                    break;
                default:
            }
        };
        injectScriptTag(Object.assign({ src, onStateUpdate }, additionalAttributes));
    }, [src]);
    return [state.loaded, state.error];
};
export default useScript;
//# sourceMappingURL=useScript.js.map